export default __webpack_public_path__ + "static/media/102_glougloux_kawai_0002.8525ea30.png";